import { useParams } from 'react-router-dom';

import { Box, VStack } from '@chakra-ui/react';

import Activities from './sections/Activities';
import ClientCenterHeader from './sections/ClientCenterHeader';
import CustomerProfile from './sections/CustomerProfile';
import Policies from './sections/Policies';
import Quotes from './sections/Quotes';
import ActurisConfigGate from './components/ActurisConfigGate';

const ClientCenterView = () => {
  const { id } = useParams<{ id: string }>();
  const customerId = id ?? '';

  return (
    <Box px="12px">
      <ActurisConfigGate>
        <ClientCenterHeader customerId={customerId} />

        <VStack spacing="6" align="stretch">
          <CustomerProfile customerId={customerId} />
          <Policies customerId={customerId} />
          <Quotes customerId={customerId} />
          <Activities customerId={customerId} />
        </VStack>
      </ActurisConfigGate>
    </Box>
  );
};

export default ClientCenterView;
